import styled from "styled-components";

import { NotificationFooterTextContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterText/styles";

export const NotificationFooterImageContainer = styled.div`
  display: flex;
  gap: 4px;

  img {
    border-radius: 1.5px;
    object-fit: contain;
  }

  ${NotificationFooterTextContainer} {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;

interface IFallbackBackgroundProps {
  backgroundColor: string;
}

export const FallbackBackground = styled.div<IFallbackBackgroundProps>`
  width: 28px;
  height: 16px;

  border-radius: 1.5px;

  background-color: ${({ backgroundColor }) => backgroundColor};
`;
